module.exports = __webpack_public_path__ + "Frame412-611aa933.webp";